/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Settings_ScopeInputs */

const en_task_settings_scope = /** @type {(inputs: Task_Settings_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Case type`)
};

const pt_br2_task_settings_scope = /** @type {(inputs: Task_Settings_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tipo de caso`)
};

/**
* | output |
* | --- |
* | "Case type" |
*
* @param {Task_Settings_ScopeInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_settings_scope = /** @type {((inputs?: Task_Settings_ScopeInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Settings_ScopeInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_settings_scope(inputs)
	return pt_br2_task_settings_scope(inputs)
});